<ng-container *ngIf="chartData">
  <app-banner
    *ngIf="(installationDetailsStore.isInstallationLegacyHP$ | async) && isElectricityConsumption"
    >{{
      '+INSTALLATIONS.INSTALLATION.ELECTRICITY_CONSUMPTION.ONLY_COMPRESSOR' | translate
    }}</app-banner
  >
  <app-chart [chartData]="chartData"></app-chart>
</ng-container>
